export default __webpack_public_path__ + "static/media/bg-boost-desktop.772154c9.svg";